module.exports = __webpack_public_path__ + "img/chickenProgress.c9ca1b3f.png";